enum LOCAL_STORAGE_KEYS {
  TOKEN = "jwt",
  CLEAR = "trpat,trptkn,token,tatv4-local,tatv4-local-local",
}

export default LOCAL_STORAGE_KEYS;
